import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

const deprecatedMaterials = {
  defaultStructuralMaterial2X4a: {
    name: "2x4 SPF and 0.5 SHEATHING",
    type: "STRUCTURE",
    thickness: 4,
  },
  defaultStructuralMaterial2X4b: {
    name: "2x4 SPF and 1 SHEATHING",
    type: "STRUCTURE",
    thickness: 4.5,
  },
  defaultStructuralMaterial2X6a: {
    name: "2x6 SPF and 0.5 SHEATHING",
    type: "STRUCTURE",
    thickness: 6,
  },
  defaultStructuralMaterial2X6b: {
    name: "2x6. SPF and 1 SHEATHING",
    type: "STRUCTURE",
    thickness: 6.5,
  },
  voidSubstrateMaterial: {
    name: "NO SHEATHING",
    type: "SUBSTRATE",
    thickness: 0,
  },
  defaultSubstrateHalf: {
    name: `Substrate 1/2" Replacer`,
    type: "SUBSTRATE",
    thickness: 0,
  },
  defaultSubstrateOne: {
    name: `Substrate 1" Replacer`,
    type: "SUBSTRATE",
    thickness: 0,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_154: DocMigration = {
  maxSchemaVersion: "0.0.154",
  description: "Maintain existing home wall assembly datums",
  apply(json: any) {
    let foundHackWallType = false;
    let foundInteriorThickening = false;
    let foundIncludeSheathing = false;

    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "WALL_CATALOG_SETTINGS") {
        const wallTypes = setting.wallTypes ?? {};

        let foundHackWallTypeInternal = false;

        for (const typeId in wallTypes) {
          const type = wallTypes[typeId];

          // rename substrateMaterialId to exteriorSubstrateMaterialId
          if (type.substrateMaterialId !== undefined) {
            type.exteriorSubstrateMaterialId = type.substrateMaterialId;
            delete type.substrateMaterialId;
          }

          if (deprecatedMaterials[type.structuralMaterialId]) {
            foundHackWallTypeInternal = true;
          }
        }

        // ensure no substrate for walls on this plan if we found a hack
        if (foundHackWallTypeInternal) {
          for (const typeId in wallTypes) {
            const type = wallTypes[typeId];
            type.exteriorSubstrateMaterialId = "voidSubstrateMaterial";
          }

          foundHackWallType = true;
        }
      }
    }

    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "WALL_SETTINGS") {
        if (
          setting.exteriorWallOffsetMode === "INSIDE_THICKENING" ||
          setting.exteriorWallOffsetMode === "INSIDE_THICKENING_ALL"
        ) {
          foundInteriorThickening = true;
        }
      }
      if (setting.type === "PLAN_SETTINGS") {
        if (setting.includeWallSheathing !== undefined) {
          if (setting.includeWallSheathing === true) {
            foundIncludeSheathing = true;
          }
          delete setting.includeWallSheathing;
        }
      }
    }

    if (foundHackWallType || foundIncludeSheathing) {
      const settingsSetId = uid();
      const settingsSet = {
        id: settingsSetId,
        entityType: "SETTINGS_SET",
        name: "Wall Datum Settings Set",
        sortIndex: -1,
      };

      json.settingsSets[settingsSetId] = settingsSet;

      if (foundInteriorThickening || foundIncludeSheathing) {
        const wallSettingsId = uid();
        const wallSettings = {
          id: wallSettingsId,
          type: "WALL_SETTINGS",
          entityType: "SETTINGS",
          name: "Wall Settings",
          sortIndex: 0,
          parentId: settingsSetId,
          exteriorWallOffsetDatum: "OUTSIDE_FACE_OF_SUBSTRATE",
        };

        json.settings[wallSettingsId] = wallSettings;

        const planSettingsId = uid();
        const planSettings = {
          id: planSettingsId,
          type: "PLAN_SETTINGS",
          entityType: "SETTINGS",
          name: "Plan Settings",
          sortIndex: 0,
          parentId: settingsSetId,
          exteriorDimensionDatum: "OUTSIDE_FACE_OF_SUBSTRATE",
        };

        json.settings[planSettingsId] = planSettings;
      }

      if (foundHackWallType) {
        const wallCatalogSettingsId = uid();
        const wallCatalogSettings = {
          id: wallCatalogSettingsId,
          type: "WALL_CATALOG_SETTINGS",
          entityType: "SETTINGS",
          name: "Wall Catalog Settings",
          sortIndex: 0,
          parentId: settingsSetId,
          wallMaterials: deprecatedMaterials,
        };

        json.settings[wallCatalogSettingsId] = wallCatalogSettings;
      }
    }

    return json;
  },
};

export default migration_0_0_154;
